const formDataSchema = {
    feilds: [        
        {
            id: 1,
            name: 'currentpassword',
            title: 'Current Password*',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'password',
            placeholder: 'Enter',
            icon: 'key',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Enter Current Password'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 2,
            name: 'newpassword',
            title: 'New Password*',
            visible: true,
            icon: 'key',
            element: 'input',
            required: true,
            input_type: 'password',
            placeholder: 'Enter',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Enter new password'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 3,
            name: 'confirmpassword',
            title: 'Confirm New Password*',
            visible: true,
            icon: 'key',
            element: 'input',
            required: true,
            input_type: 'password',
            placeholder: 'Enter',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Enter Confirm New Password'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }
    ]
};


export default formDataSchema;